module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/instagram/sola_sns_02-2a0fb38ea52b2a54eeb7fa4eaa930d43.jpg";